// extracted by mini-css-extract-plugin
export default {"form_part_module":"LoginForm_form_part_module__E6rDV","input_group_module":"LoginForm_input_group_module__+pmL+"};